import { Icon, IconProps } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
//import { ListingCardType } from '~/types/listingTypes';

export default function Attributes({
  listing,
}: {
  listing: {
    area: number;
    attributes: {
      rooms?: number;
      baths?: number;
    };
  };
}) {
  const { t } = useTranslation('app');
  const attributes: {
    icon: IconProps['name'];
    text: string;
    unit?: string;
    isVisible: boolean;
  }[] = [
    {
      icon: 'size',
      unit: t('meter'),
      text: `${listing.area}`,
      isVisible: Boolean(listing.area),
    },
    {
      icon: 'bedroom',
      text: `${listing.attributes?.rooms}`,
      isVisible: Boolean(listing.attributes?.rooms),
    },
    {
      icon: 'bathroom',
      text: `${listing.attributes?.baths}`,
      isVisible: Boolean(listing.attributes?.baths),
    },
  ];
  return (
    <div className="flex items-center flex-wrap gap-x-2x">
      {attributes.map((item) => {
        return (
          item.isVisible && (
            <div key={item.icon} className="flex items-center gap-x-x">
              <Icon name={item.icon} />
              <p className="text-caption text-gray__dark_2 whitespace-nowrap">
                {item.text} {item.unit || ''}
              </p>
            </div>
          )
        );
      })}
    </div>
  );
}
